import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { EduProjectErrorService } from 'src/app/service/context/edu/edu-project-error.service';

@Component({
    selector: 'app-edu-project-error',
    templateUrl: './edu-project-error.component.html',
    styles: []
})
export class EduProjectErrorComponent implements OnInit {
    constructor(
        private eduProjectErrorService: EduProjectErrorService,
        private toastr: ToastrService,
        public datePipe: DatePipe,
        private router: Router,
    ) { }

    eduProjectErrors: any[] = [];

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.eduProjectErrorService.getListEduProjectError().subscribe(
            res => {
                this.eduProjectErrors = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onApproval(guid) {
        this.router.navigateByUrl('/techbyte/admin/edu-project-error/edit/' + guid);
    }
}